import { DevelopusTreeTableType } from '../DevelopusTreeTable'
import DevelopusTreeTableBodyUIModel from './DevelopusTreeTableBodyUIModel'
import DevelopusTreeTableHeadUIModel from './DevelopusTreeTableHeadUIModel'

class DevelopusTreeTableUIModel {
  constructor(
    id: string,
    head: DevelopusTreeTableHeadUIModel,
    body: DevelopusTreeTableBodyUIModel,
  ) {
    this.id = id
    this.head = head
    this.body = body
  }

  private readonly id: string
  private readonly head: DevelopusTreeTableHeadUIModel
  private readonly body: DevelopusTreeTableBodyUIModel

  toUI(): DevelopusTreeTableType {
    return {
      key: this.id,
      head: this.head.toUI(),
      body: this.body.toUI(),
    }
  }
}

export default DevelopusTreeTableUIModel
